import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import SchoolIcon from '@mui/icons-material/School';
import './Education.css';
import { EducationHeading } from '../../components/Comp/AllComponents';

const Education = () => {
    return (

    <>
   
            <div className='education' id='education'>
                 <EducationHeading />
                {/* <hr /> */}


                <VerticalTimeline>
                    
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="2022 - 2024"                         
                        contentArrowStyle={{ 
                            borderLeft: '7px solid #000' 
                        }}
                        iconStyle={{ background: '#7a14ff', color: '#fff' }}
                        icon = {(<SchoolIcon className='iconEducation'/>)}
                        
                    ><div className='para'>
                        <h2 className="vertical-timeline-element-title">MCA</h2>
                        <h4 className="vertical-timeline-element-subtitle">UIT RGPV, BHOPAL(MP) </h4>
                        <p>
                            I recently given the exam of my master degree(MCA) from UIT RGPV. Year of my batch is 2024.
                        </p></div>
                    </VerticalTimelineElement>
                    
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="2019 - 2022"
                        contentArrowStyle={{ borderLeft: '7px solid #000' }}
                        iconStyle={{ background: '#7a14ff', color: '#fff' }}
                        icon = {(<SchoolIcon/>)}
                    ><div className='para'>
                        <h2 className="vertical-timeline-element-title">BCA</h2>
                        <h4 className="vertical-timeline-element-subtitle"> BARKATULLAH UNIVERSITY BHOPAL</h4>
                        <p>
                            I completed my bachelor degree(BCA) from Barkatullah University.
                        </p></div>
                    </VerticalTimelineElement>

                </VerticalTimeline>

            
            </div>


    </>


    )
}

                export default Education
